import { gql } from "graphql-request";

export const CREATE_PROJECT = gql`
  mutation CreateProject($input: CreateProjectInput!) {
    createProject(input: $input) {
      id
      title
      isSOPTemplate
      description
      labels
      tenantId
      sourceProjectId
      dueDate
      status
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const UPDATE_PROJECT = gql`
  mutation UpdateProject($input: UpdateProjectInput!) {
    updateProject(input: $input) {
      id
      title
      isSOPTemplate
      description
      labels
      tenantId
      sourceProjectId
      dueDate
      status
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const DELETE_PROJECT = gql`
  mutation DeleteProject($id: ID!) {
    deleteProject(id: $id)
  }
`;

export const INSTANTIATE_SOP = gql`
  mutation InstantiateSOP($input: InstantiateSOPInput!) {
    instantiateSOP(input: $input) {
      id
      title
      isSOPTemplate
      description
      labels
      tenantId
      sourceProjectId
      dueDate
      status
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const ASSIGN_SOP_APPROVERS = gql`
  mutation AssignSOPApprovers($input: AssignSOPApproversInput!) {
    assignSOPApprovers(input: $input) {
      id
      title
      approvalStatus
      approvedAt
      approvedByUserId
    }
  }
`;

export const APPROVE_SOP = gql`
  mutation ApproveSOP($input: ApproveSOPInput!) {
    approveSOP(input: $input) {
      id
      title
      approvalStatus
      approvedAt
      approvedByUserId
    }
  }
`;

export const RESUBMIT_SOP_APPROVAL = gql`
  mutation ResubmitSOPApproval($input: ResubmitSOPApprovalInput!) {
    resubmitSOPApproval(input: $input) {
      id
      title
      approvalStatus
      approvedAt
      approvedByUserId
    }
  }
`;

export const REJECT_SOP = gql`
  mutation RejectSOP($input: RejectSOPInput!) {
    rejectSOP(input: $input) {
      id
      title
      approvalStatus
      approvedAt
      approvedByUserId
    }
  }
`;